import { render, staticRenderFns } from "./VendorsGroupForm.vue?vue&type=template&id=4cebd99f&scoped=true"
import script from "./VendorsGroupForm.vue?vue&type=script&lang=js"
export * from "./VendorsGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cebd99f",
  null
  
)

export default component.exports